import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Layout, ProtectedRoute } from './components/layout';
import Dashboard from './pages/Dashboard';
import RequestList from './pages/RequestList';
import Analytics from './pages/Analytics';
import RequestDetail from './pages/RequestDetail';
import NewSupplier from './pages/newsupplier';
import POItemsSearch from './pages/POItemsSearch';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { LoadingProvider } from './contexts/LoadingContext';
import { RequestsProvider } from './contexts/RequestsContext';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Suppliers from './pages/Suppliers';
import SupplierDetail from './pages/SupplierDetail';
import { APP_CONFIG } from './config/app.config';

function AppContent() {
  return (
    <>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <RequestsProvider>
                    <Layout />
                  </RequestsProvider>
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="requests" element={<RequestList />} />
              <Route path="requests/:requestId" element={<RequestDetail />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="new-supplier" element={<NewSupplier />} />
              <Route path="suppliers" element={<Suppliers />} />
              <Route path="/suppliers/:id" element={<SupplierDetail />} />
              <Route path="po-items" element={<POItemsSearch />} />
            </Route>
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={APP_CONFIG.TOAST_AUTO_CLOSE}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </>
  );
}

function App() {
  return (
    <LoadingProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </LoadingProvider>
  );
}

export default App;
